// @flow

import getFeatures from './getFeatures'
import getFeature from './getFeature'

export default [
  ...getFeatures,
  ...getFeature,
]
